import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CalendarioSsoModel } from 'src/app/models/calendario-sso/CalendarioSsoModel';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { eTypeResult } from 'src/app/models/common/enumModel';
import { ISolicitudesAmpliacionAprobacionModel } from 'src/app/models/interfaces/calendario-sso/ISolicitudAmpliacionAprobacionModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { CalendarioSsoService } from 'src/app/services/calendario-sso/calendario-sso.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { SolicitudAmpliacionSsoService } from 'src/app/services/solicitud-ampliacion-sso/solicitud-ampliacion-sso.service';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  templateUrl: './sso-ampliacion-aprobacion-dialog.component.html',
  styleUrls: ['./sso-ampliacion-aprobacion-dialog.component.css']
})
export class SsoAmpliacionAprobacionDialogComponent implements OnInit {

  currentCalendar: CalendarioSsoModel;
  maxDate: Date;
  minDate: Date;
  existeAprobado: boolean = false;
  constructor(
    private storage: StorageService,
    public dialogRef: MatDialogRef<SsoAmpliacionAprobacionDialogComponent>,
    private confirmDialogService: ConfirmDialogService,
    private serviceCalendario: CalendarioSsoService,
    private alertDialogService: AlertDialogService,
    private solicitudService: SolicitudAmpliacionSsoService,
    @Inject(MAT_DIALOG_DATA) public model: ISolicitudesAmpliacionAprobacionModel) { 
      this.currentCalendar = new CalendarioSsoModel();
      this.minDate = new Date();
      this.maxDate = new Date();
      let usuario = this.storage.getCurrentUser();
    }

  ngOnInit(): void {
    this.serviceCalendario.getCurrent(1)
      .subscribe((data: CalendarioSsoModel) => {
        this.currentCalendar = data;
        this.minDate = data.fechaFin;
        this.maxDate = data.fechaCierre;
        this.model.plazoAnterior = data.fechaFin;
      });
      if(this.model.listaSolicitudes.findIndex(p=>p.aprobado)>=0)
        this.existeAprobado=true;
  }

  onNoClick(): void {
    this.dialogRef.close();
  } 
  
  Save(): void{
    
    this.confirmDialogService.open('¿Deseas guardar los cambios?'); //options
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        this.solicitudService.registrarAprobacion(this.model).subscribe((result: ActionResultModel) => {
          // console.log(data);
          if(result.type!=eTypeResult.SUCCESS){
            this.alertDialogService.open(result.message);
          }else{
            this.dialogRef.close();
            this.alertDialogService.open('Se registró su validación.');
            
          }
          
        });
      }
    });
  }

  esValido(): boolean{
    let valido:boolean=true;
    if(this.model.listaSolicitudes.find(x=>x.aprobado) !=undefined){
      if(!this.model.nuevoPlazo)
        valido=false;
    }
    if(this.model.comentarios=='')
      valido=false;

    return valido;
  }

}
